import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { alpha, Button, buttonBaseClasses, Drawer, styled } from '@mui/material';
import { IGap } from 'v3/shared/components/OnlineNavBar/types';

import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';

export const paperStyle = { style: { display: 'flex', width: '100%' } };

export const DrawerStyled = styled(Drawer)(({ theme, open }) => ({
  zIndex: '999',

  '& .MuiDrawer-paper': {
    width: '100%',
    height: '4.5rem',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,

    [theme.breakpoints.up('sm')]: {
      width: open ? '20rem' : '5rem',
    },
  },
}));

export const DrawerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0.2rem 1rem',

  [theme.breakpoints.up('xs')]: {
    paddingLeft: '.1rem',
  },
  [theme.breakpoints.up('md')]: {
    padding: '0.2rem 1rem',
  },
}));

export const AlignColumn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
}));

export const NavigationButtons = styled(Button)<{ active: boolean; variant?: string }>(
  ({ active, variant, theme }) => ({
    color: active
      ? theme.palette.common.white
      : variant === 'text'
        ? theme.palette.common.white
        : theme.palette.secondary.light,
    backgroundColor: active ? alpha(theme.palette.primary.dark, 0.6) : theme.palette.primary.main,
    borderRadius: variant === 'text' ? '0' : '0.5rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: variant === 'text' ? 'flex-start' : 'center',
    gap: '1rem',
    cursor: 'pointer',
    textTransform: 'none',
    minWidth: '100%',
    height: '3.5rem',
    flexShrink: 0,
    borderTop: active ? 'solid 2px' : 0,
    borderBottom: active ? 'solid 2px' : 0,
    borderColor: active ? theme.palette.primary.main : 'transparent',
    transition: '0s',

    [`&.${buttonBaseClasses.disabled}`]: {
      color: theme.palette.common.white,
      opacity: 0.4,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      borderBottom: variant === 'text' && !active ? 'solid 1px' : 0,
      borderColor: variant === 'text' && !active ? alpha(theme.palette.details.light, 0.3) : 'transparent',
    },
    [theme.breakpoints.up('xs')]: {
      padding: '0rem 1rem',
      border: variant !== 'text' && 0,
    },
    [theme.breakpoints.up('sm')]: {
      padding: '0rem 0.8rem',
      marginRight: '.19rem',
    },
    [theme.breakpoints.up('md')]: {
      margin: '0',
    },
  }),
);

export const NavigationGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '2rem',
  justifyContent: 'center',
  flexWrap: 'nowrap',
  borderRadius: '0.5rem',

  [theme.breakpoints.up('xs')]: {
    gap: '0',
    position: 'relative',
    right: '1rem',
  },
}));

export const Gap = styled('div')<IGap>(({ gap }) => ({
  display: 'flex',
  gap: `${gap}rem`,
}));

export const ImgStyled = styled('img')(({ theme }) => ({
  width: '7.4rem',
  height: '1.5rem',
  alignSelf: 'center',
  display: 'flex',
  [theme.breakpoints.up('md')]: {
    marginRight: '2.5rem',
  },
}));

export const CloseIconStyled = styled(ExitToAppIcon)(() => ({
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const HeadlineSmallStyled = styled(HeadlineSmall)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));
